import React, { useContext } from 'react'
import { Link, useNavigate } from 'react-router'
import { StoresContext } from '@App/contexts'
import RootStore from '@App/stores/root-store'
import { PreselectedMatchWork } from '@Entities/matching/preselected-match-work'
import { observer } from 'mobx-react'

interface MatchSearchTitleProps {
    work?: PreselectedMatchWork
}

const MatchSearchTitle = ({ work }: MatchSearchTitleProps) => {
    const { matchingStore } = useContext<RootStore>(StoresContext)
    const navigate = useNavigate()

    if (!work) {
        return <>Matching Tool</>
    }

    const returnToWork = (event: React.MouseEvent<HTMLAnchorElement>) => {
        if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) {
            return
        }
        event.preventDefault()
        matchingStore.resetStore()
        navigate(-1)
    }

    const quotedTitle = <>&ldquo;{work.title}&rdquo;</>

    return (
        <>
            You are matching for{' '}
            {work.sourcePath ? (
                <Link className="preselected-work-link" to={work.sourcePath} onClick={returnToWork}>
                    {quotedTitle}
                </Link>
            ) : (
                quotedTitle
            )}{' '}
            Matching Tool
        </>
    )
}

export default observer(MatchSearchTitle)
